import * as React from 'react';
import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

import { connect } from 'react-redux';

import GridEventView from 'grid-event.view';
import { ICalendarAppState } from '../../redux-state';

interface IGridEventExternalProps {
    event: IEvent;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type GridEventProps = IGridEventExternalProps & StateToProps;

export const GridEventBase: React.StatelessComponent<GridEventProps> = props => {
    return (
        <GridEventView {...props} />
    )
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect(mapStateToProps)(GridEventBase);